import React from 'react';
import { Link } from 'react-router-dom';

export function Portfolio() {
  return (
    <main className="stub">
      <Link to="/" className="stub__back">← Back to home</Link>
      <h2>Performance Archive</h2>
      <p>
        Full performance archive with embedded videos, programme notes, and
        concert dates lives here.
      </p>
      <p>
        Once Bertis picks an embed source (YouTube unlisted, Vimeo private, or
        self-hosted), we'll wire each entry to its video. For now, see the
        selected highlights on the{' '}
        <Link to="/#performance">home page</Link>.
      </p>
    </main>
  );
}
